import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.AddPersonWizard', {
    add: 'Add',
    back: 'Back',
    next: 'Next',
    submitAndSend: 'Submit and Send invitation',
});
